import { ToastContainer, toast } from 'react-toastify';
import { Flex, Box, Text, Avatar, IconButton } from '@radix-ui/themes';
import { Cross2Icon } from '@radix-ui/react-icons';
export default function CustomToast({closeToast, data, toastProps, isPaused}) {
    const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL
    return (
        <Flex direction="row" gap="4" align="center">
            {data.image && (
                <Avatar src={`${PUBLIC_URL}/storage/${data.image}`} fallback="M" />
            )}
            <Box style={{flex: 1}}>
                <Text weight="bold" size="2" as="p">{data.title}</Text>
                <Text size="2" as="p">{data.body}</Text>
            </Box>
            {/* <IconButton variant="ghost" onClick={closeToast}>
                <Cross2Icon />
            </IconButton> */}
        </Flex>
    )
}